/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-17 12:25:23
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title5 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import Form from './Form';

class P19 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],
      chartColorList: [],
    }
  }

  render() {
    const { chartTitle, chartList, chartColorList } = this.state;
    return (
      <Stage>
        <Title5 pageNumber="4.1">全年好感度变化</Title5>

        <div className={s.content}>
          <div>
            <div contentEditable className={s.des}>
              全年整体好感度为：92.67%，位于标杆区间；负面条数占比为7.19%，低于『数字品牌榜』所监测的1900+品牌全网均值：12.30%。①全年主要负面事件，从数字品牌价值减值来衡量，
              依次为：悦鲜活广告文案风波&gt;邓伦解约风波&gt;安贤洙解约风波。②代言人解约风波虽然传播量大，但用户对于君乐宝主要持中立态度，存在少部分调侃“连续踩雷”和批评“为什么不用中国运动员”的声音。
            </div>
          </div>

          <div className={s.uiWrapper}>
            <div className={s.chartWrapper}>
              <TooltipDrawer
                style={{ width: '100%', height: '100%' }}
                formContent={<Form onChange={values => this.setState({ ...values })} />}>
                <Chart isShow options={setChart({
                  label: chartTitle,
                  list: chartList,
                  color: chartColorList
                })} />
              </TooltipDrawer>
            </div>
          </div>
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P19);



// WEBPACK FOOTER //
// src/routes/visualChart/P19/index.js